package com.devi3east.bashbuddy.cart.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.cart.ui.CartScreenRoute

fun NavGraphBuilder.cartNavGraph(
    appState: AppState
) {
    composable(Screen.CartScreen.route) {
        CartScreenRoute(
            appState = appState
        )
    }
}